module.exports = __webpack_public_path__ + "static/wg_header-90dde34ea1ae94059bea6a8e838f36bd.jpg";